import { useLocation } from 'react-router';

import { useHasPermissions } from '~platform/auth';
import { useGetPointsOfSalesQuery } from '~platform/entities/pos';

import { ROUTES } from '~shared/config/routes';

import { Icon } from '@breezeventures/ui-kit/next/icon';

import { NavItemProps } from '../types';

export const useNavigationItems = () => {
  const { pathname } = useLocation();
  const { data: posList } = useGetPointsOfSalesQuery();
  const hasOnlineStores = posList?.some((pos) => pos.type === 'ONLINE');
  const { checkPermissions } = useHasPermissions();

  const navItems: NavItemProps[] = [];

  if (checkPermissions(['DASHBOARD_VIEW'])) {
    navItems.push({
      to: ROUTES.dashboard,
      label: 'Dashboard',
      icon: (
        <Icon name="chart-line" size={24} version="v1" className="size-6" />
      ),
    });
  }

  if (hasOnlineStores && checkPermissions(['ORDERS_VIEW'])) {
    navItems.push({
      to: ROUTES.orders.root,
      label: 'Orders',
      icon: <Icon name="folder" size={24} version="v1" className="size-6" />,
    });
  }

  if (
    checkPermissions(['APPLICATIONS_VIEW']) ||
    checkPermissions(['TRANSACTIONS_VIEW'])
  ) {
    navItems.push({
      to: pathname.startsWith(ROUTES.transactions.root)
        ? pathname
        : ROUTES.transactions.root,
      label: 'Reports',
      icon: <Icon name="coins" size={24} version="v1" className="size-6" />,
    });
  }

  return navItems;
};
